<div class="gameWrap gameLucky6">
    <div class="gameHeader">
        <!-- <button class="back leftbtn" routerLink="/dge/lobby"> -->
        <button class="back leftbtn" (click)="loadBack()">
            <a>
                <svg class="svgicon">
                    <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
                </svg>
            </a>
        </button>
        <div class="pageIndicator">
            <div class="imgWrap">
                <img src="assets/images/{{clientCode}}/gamelogo/{{rootData?.gameIcon}}"
                    alt="game-{{gameData?.gameName}}">
            </div>
            <div class="userinfo">
                <!-- **new** -whole-block -->
                <div class="userName">{{userInfo?.playername}}</div>
                <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
            </div>
        </div>
    </div>
    <div class="timeToDrawSection">
        <!-- **new** -whole-block -->
        <div class="sectionWrapper">
            <div class="section msgBlk">
                <div class="boxWrap {{myTicketCount > 0 ? 'played' : 'no-played'}}">
                    <div class="box">
                        <div class="title">{{'dge.play_ticket' | translate}}</div>
                        <div class="subTitle">{{'dge.for_draw' | translate}}</div>
                    </div>
                    <div class="value">{{ myTicketCount }}</div>
                </div>
                <div class="dmPlayBTNWrap" (click)="openDrawMachine()">
                    <button class="dmPlayBTN btn">
                        <span>{{'dge.play' | translate}}</span>
                    </button>
                </div>                                              
            </div>
            <div class="section timerBlk" *ngIf="diff_time?.fetchRuleStatus">
                <div class="label">{{'dge.curr_draw' | translate}}</div>
                <div class="timer">
                    <div class="box day" *ngIf="true">
                        <span class="num">{{diff_time?.shownTime[0]}}</span>
                        <span class="abbr">D</span>
                    </div>
                    <div class="box hour">
                        <span class="num">{{diff_time?.shownTime[1]}}</span>
                        <span class="abbr">H</span>
                    </div>
                    <div class="box minute">
                        <span class="num">{{diff_time?.shownTime[2]}}</span>
                        <span class="abbr">M</span>
                    </div>
                    <div class="box second">
                        <span class="num">{{diff_time?.shownTime[3]}}</span>
                        <span class="abbr">S</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="betTypeWrap section">
        <div class="sectionWrapper">
            <div class="betBlockWrap">
                <div class="mainBetWrap sectionBox" [ngClass]="{'current': !isSidePanel}">
                    <div class="sectionTitle">{{'dge.mainbets' | translate}}</div>
                    <ul class="buttonList">
                        <ng-container *ngFor="let betType of gameData?.betRespVOs; let i = index">
                            <li *ngIf="betType.winMode == 'MAIN'"
                                [ngClass]="{'active': userData?.panelData[panelCounter - 1]?.betType == betType.betCode}"
                                [attr.betname]="betType.betName" (click)="selectGameBet(betType.betCode)" tabindex="-1"
                                (keyup.arrowleft)="moveBetFocus($event, 'LEFT', i)"
                                (keyup.arrowright)="moveBetFocus($event, 'RIGHT', i)"
                                (focus)="selectGameBet(betType.betCode)">
                                <button>{{'dge.'+betType.betDispName | translate}}</button>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div class="sideBetWrap sectionBox" [ngClass]="{'current': isSidePanel}">
                    <div class="sectionTitle">{{'dge.sidebets' | translate}}</div>
                    <ul class="buttonList">
                        <li *ngIf="sideBetData['LuckySixFirstBallEvenOdd'] || sideBetData['LuckySixFirstBallSum'] || sideBetData['LuckySixFirstBallColor']"
                            (click)="selectSideGameBet('First Ball')" tabindex="-1"
                            [ngClass]="{'active': currentSideBet == 'First Ball'}"
                            (keyup.arrowleft)="moveBetFocus($event, 'LEFT', 0)"
                            (keyup.arrowright)="moveBetFocus($event, 'RIGHT', 0)"
                            (focus)="selectSideGameBet('First Ball')">
                            <button>
                                {{'dge.first_ball' | translate}}
                                <!-- <span class="badge">1</span> -->
                            </button>
                        </li>
                        <li *ngIf="sideBetData['LuckySixLastBallEvenOdd'] || sideBetData['LuckySixLastBallSum'] || sideBetData['LuckySixLastBallColor']"
                            (click)="selectSideGameBet('Last Ball')" tabindex="-1"
                            [ngClass]="{'active': currentSideBet == 'Last Ball'}"
                            (keyup.arrowleft)="moveBetFocus($event, 'LEFT', 1)"
                            (keyup.arrowright)="moveBetFocus($event, 'RIGHT', 1)"
                            (focus)="selectSideGameBet('Last Ball')">
                            <button>
                                {{'dge.last_ball' | translate}}
                                <!-- <span class="badge">1</span> -->
                            </button>
                        </li>
                        <li *ngIf="sideBetData['LuckySixFirstFiveMoreEvenOdd'] || sideBetData['LuckySixFirstFiveBallSum'] || sideBetData['LuckySixAllBallColor']"
                            (click)="selectSideGameBet('First 5 Ball')" tabindex="-1"
                            [ngClass]="{'active': currentSideBet == 'First 5 Ball'}"
                            (keyup.arrowleft)="moveBetFocus($event, 'LEFT', 2)"
                            (keyup.arrowright)="moveBetFocus($event, 'RIGHT', 2)"
                            (focus)="selectSideGameBet('First 5 Ball')">
                            <button>
                                {{'dge.first_5' | translate}}
                                <!-- <span class="badge">1</span> -->
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="gameplayWrap section">
        <div class="gameHeader subHeader">
            <button class="back leftbtn" (click)="loadBackPanel()">
                <svg class="svgicon">
                    <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
                </svg>
            </button>
            <div class="pageIndicator">
                <div class="title">
                    {{ currentSideBet == '' ? betData[userData?.panelData[0].betType]?.betDispName : currentSideBet}}
                </div>
                <div class="userinfo">
                    <div class="userName">{{userInfo?.playername}}</div>
                    <div class="balanceWrap" innerHTML="{{userInfo?.balance | custCurrency}}"></div>
                </div>
            </div>
        </div>
        <div class="playAreaWrapper">
            <div class="mainBetWrapper" *ngIf="!isSidePanel">
                <div class="sectionWrapper">
                    <div class="msgCopyWrap" *ngIf="postState">
                        <div class="msgTxt">{{postStateMsg}}</div>
                    </div>
                    <div class="colorMapWrap">
                        <div class="colorMap">
                            <ul class="colorList">
                                <li class="bg-red"></li>
                                <li class="bg-green"></li>
                                <li class="bg-blue"></li>
                                <li class="bg-magenta"></li>
                                <li class="bg-brown"></li>
                                <li class="bg-cyan"></li>
                                <li class="bg-orange"></li>
                                <li class="bg-grey"></li>
                            </ul>
                        </div>
                        <div class="colorMap">
                            <ul class="colorList">
                                <li class="bg-red"></li>
                                <li class="bg-green"></li>
                                <li class="bg-blue"></li>
                                <li class="bg-magenta"></li>
                                <li class="bg-brown"></li>
                                <li class="bg-cyan"></li>
                                <li class="bg-orange"></li>
                                <li class="bg-grey"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="numSelectionWrap">
                        <ul class="numSelectionBox">
                            <li class="numBox bg-{{pickNum.color}}"
                                [ngClass]="{'active': checkNumberSelected(pickNum.number)}"
                                *ngFor="let pickNum of gameData?.numberConfig.range[0].ball" id="{{pickNum.number}}"
                                (click)="selectPickedNum(pickNum.number)">
                                <span class=" txt">{{pickNum.number}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pickTypeWrap sectionBox">
                        <div class="pickWrap" *ngIf="isQP">
                            <!-- perm 2 QP option -->
                            <div class="pick-perm2qp">
                                <div class="label">{{'dge.qp' | translate}}</div>
                                <ul class="buttonList round">
                                    <li *ngFor="let qp of qpArray" (click)="qpNumbers(qp)"
                                        [ngClass]="{'active': selectedQpNum == qp}">
                                        <button>{{qp}}</button>
                                    </li>
                                </ul>
                                <div class="closeWrap" (click)="closeQP();">
                                    <div class="closeicon">X</div>
                                    <div class="txt">{{'dge.close' | translate}}</div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="!isQP && !isBankerBet">
                            <ng-container *ngFor="let betType of gameData?.betRespVOs; let i = index">
                                <ng-container
                                    *ngIf="userData?.panelData[panelCounter - 1]?.betType == betType.betCode && betType.winMode == 'MAIN'">
                                    <div class="sectionTitle">{{'dge.manual_quick' | translate}}</div>
                                    <div class="buttonListWrap">
                                        <ul class="buttonList">
                                            <ng-container
                                                *ngFor="let drawName of betType.pickTypeData.pickType; let j = index">
                                                <li [ngClass]="{'active': userData?.panelData[panelCounter - 1]?.pickType == drawName.code}"
                                                    [attr.pickname]="drawName.name"
                                                    (click)="selectGamePick(drawName.code, i)" tabindex="-1"
                                                    (keyup.arrowleft)="movePickFocus($event, 'LEFT', j)"
                                                    (keyup.arrowright)="movePickFocus($event, 'RIGHT', j)"
                                                    (focus)="selectGamePick(drawName.code, i)">
                                                    <button>{{'dge.'+drawName.name | translate}}</button>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <div class="pickWrap" *ngIf="isBankerBet">
                            <!-- Banker2 option -->
                            <div class="pick-banker2">
                                <div class="banker-box" *ngIf="bankerUPNcounter != 0"
                                    [ngClass]="{'active': checkActiveBankerPanel(userData?.panelData[panelCounter - 1]?.pickedValues[0])}">
                                    <div class="ball-box">
                                        <div class="ballWrap ball-{{[numberArray[upBankeNum]?.color]}}"
                                            *ngFor="let upBankeNum of userData?.panelData[panelCounter - 1]?.pickedValues[0]">
                                            <div class="ball"><span class="value">{{upBankeNum}}</span></div>
                                        </div>
                                    </div>
                                    <div class="label-box">{{'dge.upper_line' | translate}}</div>
                                </div>
                                <div class="banker-box" *ngIf="bankerLPNcounter != 0"
                                    [ngClass]="{'active': checkActiveBankerPanel(userData?.panelData[panelCounter - 1]?.pickedValues[1])}">
                                    <div class="ball-box">
                                        <div class="ballWrap ball-{{[numberArray[lpBankeNum]?.color]}}"
                                            *ngFor="let lpBankeNum of userData?.panelData[panelCounter - 1]?.pickedValues[1]">
                                            <div class="ball"><span class="value">{{lpBankeNum}}</span></div>
                                        </div>
                                    </div>
                                    <div class="label-box">{{'dge.lower_line' | translate}}</div>
                                </div>
                                <div class="closeWrap" (click)="closeBanker();">
                                    <div class="closeicon">X</div>
                                    <div class="txt">{{'dge.close' | translate}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="betAmountWrap sectionBox">
                        <div class="sectionTitle">{{'dge.betamt' | translate}}</div>
                        <ul class="buttonList">
                            <ng-container *ngFor="let betAmt of betAmtArray; let j = index">
                                <li *ngIf="j < 5" (click)="selectBetAmount(j, betAmt)" id="unitPrice-{{j+1}}"
                                    [ngClass]="{'active': ((j+1) == userData?.panelData[panelCounter - 1]?.betAmountMultiple ) }"
                                    (focus)="selectBetAmount(j, betAmt)">
                                    <button innerHTML="{{betAmt | custCurrency}}"></button>
                                </li>
                            </ng-container>
                            <!-- <li id="otherBtn-1" (click)="selectOtherAmount($event)" (focus)="selectOtherAmount($event)"
                                [ngClass]="{'active' : userData?.panelData[panelCounter - 1]?.betAmountMultiple > 5}">
                                <button>{{'dge.other' | translate}}</button>
                            </li> -->
<!--                            <li [ngClass]="{'active' : activateOtherAmt()}"-->
<!--                                *ngIf="gameData?.betRespVOs[0]?.maxBetAmtMul * gameData?.betRespVOs[0]?.unitPrice != gameData?.betRespVOs[0]?.unitPrice">-->
<!--                                <button class="otherBtn" id="otherBtn-1" [ngClass]="{'selected': showOtherAmountInput}"-->
<!--                                    (click)="selectOtherAmount($event)" (focus)="selectOtherAmount($event)">-->
<!--                                    <span class="label">{{'dge.other' | translate}}</span>-->
<!--                                    <span class="currency">{{userInfo?.currDisplay | currencySymbol}}</span>-->
<!--                                    <input type="text" id="otherAmt-1" [(ngModel)]="otherAmtVal" name="otherTextBox"-->
<!--                                        (keyup)="onOtherAmtInputChange($event)" maxlength="6">-->
<!--                                </button>-->
<!--                            </li>-->
                        </ul>
                        <span class="error">{{betError}}</span>
                    </div>
                </div>
            </div>
            <div class="sideBetWrapper" *ngIf="isSidePanel">
                <div class="sectionWrapper">
                    <div class="msgCopyWrap">
                        <div class="msgTxt">{{'dge.side_picktype_header' | translate}}</div>
                    </div>
                    <div class="sideBets">
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixFirstBallColor'] && currentSideBet == 'First Ball'">
                            <div class="label">{{'dge.color' | translate}}
                                <span class="odds">
                                    ({{'dge.pays' | translate}}:
                                    <span class="value">&nbsp; x{{gameSchemas['LuckySixFirstBallColor']?.prizeAmount | number}}</span>)
                                </span>
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixFirstBallColor'].unitPrice | custCurrency}}">
                                </div>
                            </div>
                            <div class="betItem">
                                <ul class="ballList">
                                    <li *ngFor="let sideUnitbet of sideBetData['LuckySixFirstBallColor'].pickTypeData.pickType; let i = index;"
                                        (click)="selectSideBet('LuckySixFirstBallColor', sideUnitbet.code, i)">
                                        <div class="ballWrap ball-{{sideUnitbet.range[0].pickValue.split('<')[1] | lowercase}}"
                                            [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixFirstBallColor'][i].betAmountMultiple}">
                                            <div class="ball">
                                                <span
                                                    class="value">{{sideUnitbet.range[0].pickValue.split('<')[1] | titlecase}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixFirstBallSum'] && currentSideBet == 'First Ball'">
                            <div class="label">{{'dge.val_ball' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixFirstBallSum'].unitPrice | custCurrency}}"></div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixFirstBallSum'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixFirstBallSum'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixFirstBallSum', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{sideUnitbet.range[0].pickValue.split('<')[0] == '0' ? '&lt; '+sideUnitbet.range[0].pickValue.split('<')[2] : '&gt; '+sideUnitbet.range[0].pickValue.split('<')[0]}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixFirstBallSum']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixFirstBallEvenOdd'] && currentSideBet == 'First Ball'">
                            <div class="label">{{'dge.even_odd' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixFirstBallEvenOdd'].unitPrice | custCurrency}}">
                                </div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixFirstBallEvenOdd'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixFirstBallEvenOdd'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixFirstBallEvenOdd', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{(sideUnitbet.range[0].pickValue.split('<')[1] == 'ODD' ? 'dge.odd' : 'dge.even') | translate}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixFirstBallEvenOdd']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixLastBallColor'] && currentSideBet == 'Last Ball'">
                            <div class="label">{{'dge.color' | translate}}
                                <span class="odds">
                                    ({{'dge.pays' | translate}}:
                                    <span class="value">&nbsp; x{{gameSchemas['LuckySixLastBallColor']?.prizeAmount | number}}</span>)
                                </span>
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixLastBallColor'].unitPrice | custCurrency}}"></div>
                            </div>
                            <div class="betItem">
                                <ul class="ballList">
                                    <li *ngFor="let sideUnitbet of sideBetData['LuckySixLastBallColor'].pickTypeData.pickType; let i = index;"
                                        (click)="selectSideBet('LuckySixLastBallColor', sideUnitbet.code, i)">
                                        <div class="ballWrap ball-{{sideUnitbet.range[0].pickValue.split('<')[1] | lowercase}}"
                                            [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixLastBallColor'][i].betAmountMultiple}">
                                            <div class="ball">
                                                <span
                                                    class="value">{{sideUnitbet.range[0].pickValue.split('<')[1] | titlecase}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox" *ngIf="sideBetData['LuckySixLastBallSum'] && currentSideBet == 'Last Ball'">
                            <div class="label">{{'dge.val_ball' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixLastBallSum'].unitPrice | custCurrency}}"></div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixLastBallSum'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixLastBallSum'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixLastBallSum', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{sideUnitbet.range[0].pickValue.split('<')[0] == '0' ? '&lt; '+sideUnitbet.range[0].pickValue.split('<')[2] : '&gt; '+sideUnitbet.range[0].pickValue.split('<')[0]}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixLastBallSum']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixLastBallEvenOdd'] && currentSideBet == 'Last Ball'">
                            <div class="label">{{'dge.even_odd' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixLastBallEvenOdd'].unitPrice | custCurrency}}">
                                </div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixLastBallEvenOdd'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixLastBallEvenOdd'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixLastBallEvenOdd', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{(sideUnitbet.range[0].pickValue.split('<')[1] == 'ODD' ? 'dge.odd' : 'dge.even') | translate}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixLastBallEvenOdd']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixAllBallColor'] && currentSideBet == 'First 5 Ball'">
                            <div class="label">{{'dge.color' | translate}}
                                <span class="odds">
                                    ({{'dge.pays' | translate}}:
                                    <span class="value">&nbsp; x{{gameSchemas['LuckySixAllBallColor']?.prizeAmount | number}}</span>)
                                </span>
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixAllBallColor'].unitPrice | custCurrency}}"></div>
                            </div>
                            <div class="betItem">
                                <ul class="ballList">
                                    <li *ngFor="let sideUnitbet of sideBetData['LuckySixAllBallColor'].pickTypeData.pickType; let i = index;"
                                        (click)="selectSideBet('LuckySixAllBallColor', sideUnitbet.code, i)">
                                        <div class="ballWrap ball-{{sideUnitbet.range[0].pickValue.split('<')[1] | lowercase}}"
                                            [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixAllBallColor'][i].betAmountMultiple}">
                                            <div class="ball">
                                                <span
                                                    class="value">{{sideUnitbet.range[0].pickValue.split('<')[1] | titlecase}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixFirstFiveBallSum'] && currentSideBet == 'First 5 Ball'">
                            <div class="label">{{'dge.sum_ball' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixFirstFiveBallSum'].unitPrice | custCurrency}}">
                                </div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixFirstFiveBallSum'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixFirstFiveBallSum'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixFirstFiveBallSum', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{sideUnitbet.range[0].pickValue.split('<')[0] == '0' ? '&lt; '+sideUnitbet.range[0].pickValue.split('<')[2] : '&gt; '+sideUnitbet.range[0].pickValue.split('<')[0]}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixFirstFiveBallSum']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="betBox"
                            *ngIf="sideBetData['LuckySixFirstFiveMoreEvenOdd'] && currentSideBet == 'First 5 Ball'">
                            <div class="label">{{'dge.more_even_odd' | translate}}
                                <div class="betPrice"
                                    innerHTML="{{sideBetData['LuckySixFirstFiveMoreEvenOdd'].unitPrice | custCurrency}}">
                                </div>
                            </div>
                            <div class="betItem">
                                <ul class="btnGroup">
                                    <li class="btn"
                                        *ngFor="let sideUnitbet of sideBetData['LuckySixFirstFiveMoreEvenOdd'].pickTypeData.pickType; let i = index;"
                                        [ngClass]="{'active' : 1 == sideUserData.panelData['LuckySixFirstFiveMoreEvenOdd'][i].betAmountMultiple}"
                                        (click)="selectSideBet('LuckySixFirstFiveMoreEvenOdd', sideUnitbet.code, i)">
                                        <button>
                                            <span class="txt">
                                                {{(sideUnitbet.range[0].pickValue.split('<')[1] == 'ODD' ? 'dge.more_odd' : 'dge.more_even') | translate}}
                                            </span>
                                            <span class="odds">
                                                ({{'dge.pays' | translate}}:
                                                <span class="value">&nbsp; x{{gameSchemas['LuckySixFirstFiveMoreEvenOdd']?.prizeAmount | number}}</span>)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="addResetWrap mainBetPanelReset fix-bottom" *ngIf="!isSidePanel">
            <div class="sectionWrapper">
                <!-- style="display: none;" on postState or preState-->
                <div class="postState" [ngClass]="{'hide': postState}">
                    <div class="postStateInner">
                        <div class="powerzone type1">
                            <div class="betInfoWrap">
                                <div class="betInfo">
                                    <div class="txt">{{numberOfLines(0)}}</div>
                                    <div class="label">{{'dge.no_line' | translate}}</div>
                                </div>
                                <div class="betInfo">
                                    <div class="txt" innerHTML="{{calculatePanelPrice(0) | custCurrency}}"></div>
                                    <div class="label">{{'dge.bet_val' | translate}}</div>
                                </div>
                            </div>
                            <button class="reset" (click)="resetUserData()">
                                <svg class="svgicon">
                                    <use xlink:href="assets/images/sprite-sheet.svg#icon-reset"></use>
                                </svg>
                                <div class="txt">{{'dge.reset' | translate}}</div>
                            </button>
                            <button class="info" (click)="openHelpModal(gameCode)">
                                <span class="infoIcon">i</span>
                                <div class="txt"
                                    innerHtml="{{'common.rultoply' | translate:{gameCode: 'common.'+gameCode | translate} }}">
                                </div>
                            </button>
                            <button class="addBet btn-primary" (click)="addMainPanel()"
                                [disabled]="calculatePanelPrice(0) == 0"
                                [ngClass]="{'disabled':calculatePanelPrice(0) == 0}">
                                {{'dge.addbet' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="preState" [ngClass]="{'hide': !postState}">
                    <div class="preStateInner">
                        <div class="msgTxt">{{postStateMsg}}</div>
                        <!-- <div class="msgTxt">To play, Select 2 numbers from 1 to 90 in selected <span
                                class="highlight">manual</span> pick type.</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="addResetWrap sideBetPanelReset fix-bottom" *ngIf="isSidePanel">
            <div class="sectionWrapper">
                <!-- style="display: none;" on postState or preState-->
                <div class="postState" [ngClass]="{'hide': postState}">
                    <div class="postStateInner">
                        <div class="powerzone type1">
                            <div class="betInfoWrap">
                                <div class="betInfo">
                                    <div class="txt">{{getSidePanelDetail()[0]}}</div>
                                    <div class="label">{{'dge.no_line' | translate}}</div>
                                </div>
                                <div class="betInfo">
                                    <div class="txt" innerHTML="{{getSidePanelDetail()[1] | custCurrency}}"></div>
                                    <div class="label">{{'dge.bet_val' | translate}}</div>
                                </div>
                            </div>
                            <button class="reset" (click)="resetSideUserData()">
                                <svg class="svgicon">
                                    <use xlink:href="assets/images/sprite-sheet.svg#icon-reset"></use>
                                </svg>
                                <div class="txt">{{'dge.reset' | translate}}</div>
                            </button>
                            <button class="info" (click)="openHelpModal(gameCode)">
                                <span class="infoIcon">i</span>
                                <div class="txt"
                                    innerHtml="{{'common.rultoply' | translate:{gameCode: 'common.'+gameCode | translate} }}">
                                </div>
                            </button>
                            <button class="addBet btn-primary" (click)="addSidePanel()"
                                [disabled]="getSidePanelDetail()[1] == 0"
                                [ngClass]="{'disabled':getSidePanelDetail()[1] == 0}">
                                {{'dge.addbet' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="preState" [ngClass]="{'hide': !postState}">
                    <div class="preStateInner">
                        <div class="msgTxt">{{'dge.side_picktype_header' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="purchaseOuterWrap"></div>
    <div class="confirmPurchaseOuterWrap"></div>
    <div class="infobtnWrap" (click)="openHelpModal(gameCode)">
        <button class="info">
            <span class="infoIcon">i</span>
            <div class="txt" innerHtml="{{'common.rultoply' | translate:{gameCode: 'common.'+gameCode | translate} }}">
            </div>
        </button>
    </div>
</div>
<div class="game-start-timer-wrap" *ngIf="saleTimerStatus">
    <div class="game-start-timer">
        <div class="titleWrap">
            <div class="title1">{{'common.market_unavailable' | translate}}</div>
            <div class="title2">{{'common.sale_start' | translate}}</div>
        </div>
        <div class="timerWrap">
            <div class="timer">
                <div class="unit days" *ngIf="diff_time?.convention.includes('day')">
                    <div class="value">{{diff_time?.saleShownTime[0]}}</div>
                    <div class="label">{{diff_time?.shownTime[0] == 1 ? 'Day' : 'Days'}}</div>
                </div>
                <div class="unit hours"
                    *ngIf="diff_time?.convention.includes('day') || diff_time?.convention.includes('hr')">
                    <div class="value">{{diff_time?.saleShownTime[1]}}</div>
                    <div class="label">{{diff_time?.shownTime[1] == 1 ? 'Hour' : 'Hours'}}</div>
                </div>
                <div class="unit minutes">
                    <div class="value">{{diff_time?.saleShownTime[2]}}</div>
                    <div class="label">{{diff_time?.shownTime[2] == 1 ? 'Minute' : 'Minutes'}}</div>
                </div>
                <div class="unit seconds">
                    <div class="value">{{diff_time?.saleShownTime[3]}}</div>
                    <div class="label">{{diff_time?.shownTime[3] == 1 ? 'Second' : 'Seconds'}}</div>
                </div>
            </div>
        </div>
        <div class="actionBtnWrap">
            <button class="btn btn-rules" (click)="openHelpModal(gameCode)"
                innerHtml="{{'common.rultoply' | translate:{gameCode: ''} }}"></button>
            <button class="btn btn-results" routerLink="/dge/results/{{gameCode}}" routerLinkActive="active"
                innerHTML="{{'common.prev_res' | translate}}"></button>
        </div>
    </div>
</div>
<div class="game-start-timer-wrap" *ngIf="!activeDrawStatus">
    <div class="game-start-timer">
        <div class="titleWrap">
            <div class="title1">{{'dge.noDraws' | translate}}</div>
            <div class="title2"></div>
        </div>
        <div class="timerWrap">
            <svg id="b21613c9-2bf0-4d37-bef0-3b193d34fc5d" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                width="647.63626" height="632.17383" viewBox="0 0 647.63626 632.17383">
                <path
                    d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z"
                    transform="translate(-276.18187 -133.91309)" fill="#f2f2f2" />
                <path
                    d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z"
                    transform="translate(-276.18187 -133.91309)" fill="#3f3d56" />
                <path
                    d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z"
                    transform="translate(-276.18187 -133.91309)" fill="#1a67d5" />
                <circle cx="190.15351" cy="24.95465" r="20" fill="#1a67d5" />
                <circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff" />
                <path
                    d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z"
                    transform="translate(-276.18187 -133.91309)" fill="#e6e6e6" />
                <path
                    d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z"
                    transform="translate(-276.18187 -133.91309)" fill="#3f3d56" />
                <path
                    d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z"
                    transform="translate(-276.18187 -133.91309)" fill="#1a67d5" />
                <circle cx="433.63626" cy="105.17383" r="20" fill="#1a67d5" />
                <circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff" />
            </svg>
        </div>
        <div class="actionBtnWrap">
            <button class="btn btn-rules" (click)="openHelpModal(gameCode)"
                innerHtml="{{'common.rultoply' | translate:{gameCode: ''} }}"></button>
            <button class="btn btn-results" routerLink="/dge/results/{{gameCode}}" routerLinkActive="active"
                innerHTML="{{'common.prev_res' | translate}}"></button>
        </div>
    </div>
</div>

<!-- modal-box:: "Other" Bet Amount -->
<!-- <div class="modal-box modal-xs modal-design1" *ngIf="showOtherAmountInput">
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">{{'dge.amt' | translate}}</div>
            <div class="modal-close" (click)="closeOtherAmountInput()"><span></span></div>
        </div>
        <div class="modal-body">
            <div class="otherAmount">
                <ul class="buttonList">
                    <ng-container *ngFor="let betAmt of betAmtArray; let j = index">
                        <li *ngIf="j > 4" (click)="selectOtherBetAmount(j, betAmt)" id="unitPrice-{{j+1}}"
                            [ngClass]="{'active': (j+1) == otherBetAmountMultiple}"
                            (focus)="selectOtherBetAmount(j, betAmt)">
                            <button><span
                                    class="currency">{{userInfo?.currDisplay | currencySymbol}}</span>{{betAmt | number:'1.2-2'}}</button>
                        </li>
                    </ng-container>
                </ul>
                <div class="inputWrap">
                    <label for="otherBetAmount">{{'dge.amt' | translate}}</label>
                    <input type="text" id="otherAmt-1" [(ngModel)]="otherAmtVal"
                        (keyup)="onOtherAmtInputChange($event)">
                    <span class="error">{{betError}}</span>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="buttonWrap" (click)="closeOtherAmountInput()">
                <a>
                    <div class="cancelBtn button">
                        <div class="text">{{'dge.cancel' | translate}}</div>
                    </div>
                </a>
            </div>
            <div class="buttonWrap" (click)="continueOtherAmountInput()">
                <a>
                    <div class="goBtn button">
                        <div class="text">{{'dge.cont' | translate}}</div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div> -->





